import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { FormGroup, AbstractControl, FormBuilder, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { MatSnackBar } from '@angular/material';
import { ConvertService } from 'src/app/services/convert.service';
import { AuthStore } from 'src/app/stores/auth/auth.store';
import { ResourceStore } from 'src/app/stores/resources/resource.store';
import { DataService } from 'src/app/services/data.service';
import { IModule } from 'src/app/interfaces/resource';
import { STATUS_OBJECT, DISPLAY_STATUS_OBJECT } from 'src/app/dummy/status';
import { COLLECTION_NAME } from 'src/app/dummy/app';

@Component({
  selector: 'app-training-module-form',
  templateUrl: './training-module-form.component.html',
  styleUrls: ['./training-module-form.component.scss']
})
export class TrainingModuleFormComponent implements OnInit {
  @ViewChild('focusInput', {static:false}) inputEl: ElementRef;
  ITEM_KEY: any;
  ITEM: IModule;
  TITLE: any = "Add new module"
  SKILL_LIST: any[] = [];
  ACTIVITY_TYPE_LIST: any[] = [];
  DIFFICULTY_LIST: any[] = [];

  form: FormGroup;
  name: AbstractControl;
  activityType: AbstractControl;
  skill: AbstractControl;
  description: AbstractControl;
  difficulty: AbstractControl;

  processNew: boolean = false;
  processClose: boolean = false;
  error: any = null;
  isLinear = false;
  LOADING: boolean = true;
  LESSON_KEY: any;

  fetchSkillRef: any = null;
  fetchActivityTypeRef: any = null;
  fetchDifficultyRef: any = null;
  fetchLessonRef: any = null;

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private auth: AuthStore,
    public store: ResourceStore,
    public ds: DataService,
    private snackBar: MatSnackBar,
  ) { }

  async ngOnInit() {
    this.form = this.fb.group({
      name: [null, Validators.required],
      description: [null],
      activityType: [null, Validators.required],
      skill: [null, Validators.required],
      difficulty: [null, Validators.required],
    })
    await this.auth.fetchUser()
    this.route.params.subscribe(async param => {
      const { id, lessonKey } = param;
      this.LOADING = true;
      this.ITEM = id !== 'draft' ? await this.store.fetchSelectedData(COLLECTION_NAME.MODULE, id) : null;
      this.ITEM_KEY = id || null;
      this.LESSON_KEY = lessonKey || null;
      if (this.ITEM) {
        const { description, name, } = this.ITEM;
        this.form.patchValue({
          name,
          description,
        })
      }
      this.fetchSkillRef = this.ds.dbRef().collection(COLLECTION_NAME.SKILL, ref => ref.orderBy('name'))
        .valueChanges()
        .subscribe((docs: any) => {
          this.SKILL_LIST = docs;
          this.form.patchValue({ skill: docs[0] })
          if (this.ITEM) {
            this.form.patchValue({
              skill: docs.find(m => m.key === this.ITEM.default_skill)
            })
          }
        })

      this.fetchActivityTypeRef = this.ds.dbRef().collection(COLLECTION_NAME.ACTIVITY_TYPE, ref => ref.orderBy('name'))
        .valueChanges()
        .subscribe((docs: any) => {
          this.ACTIVITY_TYPE_LIST = docs;
          this.form.patchValue({ activityType: docs[0] })
          if (this.ITEM) {
            this.form.patchValue({
              activityType: docs.find(m => m.key === this.ITEM.activityTypeKey)
            })
          }
        })

      this.fetchDifficultyRef = this.ds.dbRef().collection(COLLECTION_NAME.DIFFICULTY, ref => ref.orderBy('difficulty'))
        .valueChanges()
        .subscribe((docs: any) => {
          this.DIFFICULTY_LIST = docs;
          this.form.patchValue({ difficulty: docs[0] })
          if (this.ITEM) {
            this.form.patchValue({
              difficulty: docs.find(m => m.key === this.ITEM.difficultyKey)
            })
          }
        })
      this.fetchLessonRef = this.ds.lessonColRef().doc(this.LESSON_KEY)
        .valueChanges()
        .subscribe((doc: any) => {
          if (!doc) {
            alert("Invalid lesson! Please try to select lesson again!")
            return;
          }
          if (!this.ITEM) {
            this.form.patchValue({ name: doc.name })
          }
          this.LOADING = false;
        })
    })
  }

  ngOnDestroy(): void {
    this.fetchActivityTypeRef && this.fetchActivityTypeRef.unsubscribe();
    this.fetchDifficultyRef && this.fetchDifficultyRef.unsubscribe();
    this.fetchLessonRef && this.fetchLessonRef.unsubscribe();
    this.fetchSkillRef && this.fetchSkillRef.unsubscribe();
  }

  onSave(f: any, isDraft: boolean) {
    this.processClose = isDraft ? false : true;
    this.processNew = isDraft;
    this.error = null;

    if (this.form.valid) {
      this.form.disable();
      const { name, description, activityType, skill, difficulty } = f;
      const { uid, selectedCompanyKey } = this.auth;
      const registerStatus = STATUS_OBJECT.submitted;
      const item: IModule = {
        key: this.ITEM ? this.ITEM.key : this.ds.createId(),
        status: DISPLAY_STATUS_OBJECT.ACTIVE,
        isDelete: false,
        created_at: this.ITEM ? this.ITEM.created_at : this.ds.serverTimestamp(),
        created_by: this.ITEM ? this.ITEM.created_by : uid,
        updated_at: this.ds.serverTimestamp(),
        updated_by: uid,
        date_key: this.ITEM ? this.ITEM.date_key : ConvertService.dateKey(),
        page_key: this.ITEM ? this.ITEM.page_key : ConvertService.pageKey(),
        keyword: [ConvertService.toCapitalize(`${name.trim()}`), difficulty.key, activityType.key, activityType.key],
        organizationRef: this.ds.companyRef().doc(selectedCompanyKey).ref,
        organizationKey: selectedCompanyKey,
        created_byRef: this.ITEM ? this.ITEM.created_byRef : this.ds.userProfileRef().doc(uid).ref,
        updated_byRef: this.ds.userProfileRef().doc(uid).ref,
        register_status: registerStatus,
        //fields
        name: name.trim(),
        description,
        activityTypeKey: activityType.key,
        activityTypeRef: this.ds.activityTypeRef().doc(activityType.key).ref,
        difficultyKey: difficulty.key,
        difficultyRef: this.ds.difficultyRef().doc(difficulty.key).ref,
        //skill
        skillData: skill,
        activityTypeData: activityType,
        difficultyData: difficulty,
        skillRef: [{ key: skill.key, ref: this.ds.skillRef().doc(skill.key).ref }],
        skillKey: [skill.key],
        default_skill: skill.key,
        lessonKey: this.LESSON_KEY,
        lessonRef: this.ds.lessonColRef().doc(this.LESSON_KEY).ref,
      }
      this.store.addItem(COLLECTION_NAME.MODULE, item, (success, res) => {
        if (success) {
          this.snackBar.open("Module has been saved successful.", "Done", { duration: 2500 });
          this.form.reset();
        }
        this.form.enable();
        this.processNew = false;
        this.processClose = false;
        if (!this.ITEM) {
          this.router.navigate([`/modules/activity-type/${item.activityTypeKey}/${item.default_skill}/${item.key}/draft`])
        }
        else {
          this.router.navigate([`/modules/submitted/${this.LESSON_KEY}/lesson`])
        }
      })
    }
    else {
      this.inputEl.nativeElement.focus();
      this.processNew = false;
      this.processClose = false;
    }
  }

  goBack() {
    const status = 'submitted'
    this.router.navigate([`/modules/${status}/${this.LESSON_KEY}/lesson`])
  }

}
